import React, { useState, useEffect } from 'react';
import { Text, TouchableOpacity, View } from 'react-native';

interface CountdownTimerProps {
  duration: number; // Duration in seconds
  onRestart: () => void; // Function to restart the timer
}

export const CountdownTimer: React.FC<CountdownTimerProps> = ({ duration, onRestart }) => {
  const [remainingTime, setRemainingTime] = useState(duration);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      if (remainingTime > 0) {
        setRemainingTime(prevTime => prevTime - 1);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [remainingTime]);

  useEffect(() => {
    setIsButtonDisabled(remainingTime > 0);
  }, [remainingTime]);

  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60)
      .toString()
      .padStart(2, '');
    const seconds = (time % 60).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;
  };

  const handleRestart = () => {
    setRemainingTime(duration); // Reset remaining time to the initial duration
    onRestart(); // Call the restart callback function
  };

  return (
    <>
      <View
        style={{
          flex: 1,
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <View
          style={{
            flex: 1,
            flexDirection: 'row',
          }}
        >
          <Text>Time Remaining: </Text>
          <Text>{formatTime(remainingTime)}</Text>
        </View>

        <TouchableOpacity onPress={handleRestart} disabled={isButtonDisabled}>
          <Text
            style={{
              color: isButtonDisabled ? '#999' : '#000',
              textDecorationLine: 'underline',
              fontWeight: 'bold',
            }}
          >
            Resend OTP
          </Text>
        </TouchableOpacity>
      </View>
    </>
  );
};

export default CountdownTimer;
